<template>
  <div class="wrapper">
    <div class="fundDoc">
        <span class="fundDoctext">{{rightTipValue}}</span>
    </div>
    <div class="header">
      <FundNameView :name="fundName" :code="''" />
      <div class="header-tags">
        <span class="xfnextCode">{{fundCode}}</span>
        <span class="xftag-text"
        v-if="pageData.riskLevel !== '--'" @click="showRiskFundType" >{{pageData.riskLevel}}</span>
        <span class="xftag-text"
           v-if="pageData.FTYPE" @click="showFundType">{{getTypeName(pageData.FTYPE)}}</span>
      </div>
      <div class="labelmid">{{middTip}}</div>
      <div v-if="fundStatus !== 2">
        <CountDown
          :endTime="downEndTime"
          :bgColor="fundStatus === 0 ? '#408FFF':'#ff4400'"
          @timeup="timeUp"
          ref="CountDown"
        />
      </div>
      <div v-else class="endTip">
        等待成立
      </div>
      <div>
        <div class="rengouqi">认购期</div>
        <div class="rengouqiStr">{{rgqStr}}</div>
      </div>
    </div>
    <!-- <WarningBar v-if="fundStatus !== 2"
     :closable="false" content="认购期仅供参考，以基金公司公告为准。为避免基金认购提前结束，建议加入自选并及时关注募集结束时间。" /> -->
  </div>
</template>

<script>

// import WarningBar from '@/components/Warning-Tip.vue';
import CountDown from '@/components/Fund-Count-Down.vue';
import FundNameView from '@/components/Fund-FundNameVIew.vue';
import JS from '@/base/JSTool';
import Util from '@/base/Util';
import NativeMsg from '@/base/NativeMsg';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'fund-header-new',
  props: {},
  watch: {},
  data() {
    return {
      pageData: {},
      fundCode: '',
      fundName: '',
      fundType: '',
      fundStatus: 0,
      downEndTime: '--',
      middTip: '--',
      rightTipValue: '--',
      showwap: false,
      rgqStr: '--～--',
    };
  },
  computed: {
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
    this.handleDefault();
  },
  mounted() {},
  methods: {
    collectPeriod() {
      const { ISSBDATE, ISSEDATE } = StoreManger.getFundJJXQ();
      if (Util.isEmpty(ISSBDATE) || Util.isEmpty(ISSEDATE)) {
        return '';
      }
      return `${ISSBDATE.substr(0, 16)}~${ISSEDATE.substr(0, 16)}`;
    },
    render() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        this.showwap = true;
      }
      // #endif
      const fundinfo = StoreManger.getFundJJXQ();
      this.fundName = StoreManger.getFundJJXQNAME(fundinfo);
      this.handleData(fundinfo);
      this.rgqStr = this.collectPeriod();
      const timer = setInterval(() => {
        const refs = this.$refs;
        if (refs.CountDown) {
          refs.CountDown.closeTime();
          refs.CountDown.render();
          clearInterval(timer);
        }
      }, 300);
    },
    handleDefault() {
      this.handleData(null);
    },
    handleData(item) {
      this.pageData = this.format(item);
      this.fundStatus = this.getfundStatus();

      const { ISSBDATE } = this.pageData;
      const { ISSEDATE } = this.pageData;
      if (this.fundStatus === 0) {
        this.middTip = '距离开售还有';
        this.rightTipValue = '即将开售';
      } else if (this.fundStatus === 2) {
        this.middTip = `${ISSEDATE.slice(2, 10)} 结束募集`;
        this.rightTipValue = '募集结束';
      } else {
        this.middTip = '距离认购结束还剩';
        this.rightTipValue = '募集中';
      }
      if (this.fundStatus === 0) {
        this.downEndTime = ISSBDATE;
      } else {
        this.downEndTime = ISSEDATE;
      }
    },

    format(item) {
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      const ISSBDATE = fetch('ISSBDATE');
      const ISSEDATE = fetch('ISSEDATE');
      const BUY = fetch('BUY') === '1';

      return {
        ISSBDATE,
        ISSEDATE,
        BUY,
        FTYPE: fetch('FTYPE'),
        riskLevel: (() => {
          const RISKLEVEL = fetch('RISKLEVEL');
          if (RISKLEVEL === '--' || !RISKLEVEL) {
            return '--';
          }
          // if (RISKLEVEL === '5') {
          //   return '高风险';
          // }
          // return '--';
          return RISKLEVEL === '--'
            ? '低风险'
            : `${['低', '中低', '中', '中高', '高'][RISKLEVEL - 1]}风险`;
        })(),
      };
    },
    timeUp() {
      // TODO:
      console.log('sdsdsds timeUp');
      NativeMsg.post(JSON.stringify({ key: 'refreshNewState', value: { state: 1 } }));
      this.render();
    },
    getTypeName(item) {
      let ishqb = '0';
      const fundData = StoreManger.getFundJJXQ();
      const BAGTYPE = JS.fetchString(fundData, 'BAGTYPE');
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (ishqb === '1') {
        return '活期宝';
      }
      return item;
    },
    showRiskFundType() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${code}`,
      });
      this.reportMonitor({
        eventName: 'pz.top.risk',
      });
    },
    showFundType() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${code}`,
      });
      this.reportMonitor({
        eventName: 'pz.top.type',
      });
    },
    getfundStatus() {
      if (!this.pageData) {
        return '';
      }
      const { ISSBDATE, ISSEDATE } = this.pageData;
      if (Util.isEmpty(ISSBDATE) || Util.isEmpty(ISSEDATE)) {
        return '';
      }
      const startDate = new Date(ISSBDATE.replace(/-/g, '/')).getTime();
      const endDate = new Date(ISSEDATE.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();

      if (endDate > startDate) {
        if (startDate > serverDate) {
          return 0;
        }
        if (endDate >= serverDate) {
          return 1;
        }
        return 2;
      }
      return '';
    },
  },
  components: {
    CountDown,
    FundNameView,
  },
};
</script>

<style scoped lang="less">
.wrapper{
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
}
.header {

  border-radius: 10px;
  position: relative;
  padding-left: 30px;
  padding-right: 10px;
  padding-bottom: 10px;
  background: #ffffff;
  color: #000;
}
.header-tags {
  // border-top: 1px solid rgba(255, 255, 255, 0.2);
  height: 60px;
  text-align: left;
  font-size: 24px;
  display:flex;
  flex-wrap: wrap;
  flex-direction:row;
  overflow:hidden;
  margin-top: 4px;
  margin-bottom: 6px;
}
.xftag-text {
  margin-right: 8px;
  margin-top: 14px;
  margin-bottom: 4px;
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  line-height: normal;
  align-items: center;
  justify-content: center;
  color: #52a2ff;
  background-color: rgba(82, 162, 255, 0.1);
}
.labelmid {
  margin-top: 20px;
  font-size: 26px;
  color: #999999;
}
.endTip{
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 55px;
  color: #000;
}
.fundDoc {
  z-index: 99;
  background: rgba(255, 100, 52, 0.1);
  border-top-left-radius: 0px;
  border-bottom-left-radius: 8px;
  position: absolute;
  margin-top: 0px;
  right: 30px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.fundDoctext{
  font-size: 28px;
  color: #ff6433;
  line-height: 36px;
  margin: 6px 14px;
}
.rengouqi{
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #999999;
  text-align: justify;
  margin-bottom: 16px;
}
.rengouqiStr{
  font-family: DINAlternate-Bold;
  font-size: 36px;
  color: #000000;
  margin-bottom: 26px;
}

.xfnextCode{
  margin-right: 8px;
  margin-top: 14px;
  margin-bottom: 4px;
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  line-height: normal;
  align-items: center;
  justify-content: center;
  color: #999999;
}
</style>
